<template>
    <div id="settingsPage">
        <AppBreadCrumb :show-trial-remain-day="true" :paths="[{ title: $t('message.settings') }]" />
        <b-container fluid>
            <b-row>
                <b-col class="mt-3" md="3">
                    <h6>{{ $t("message.general") }}</h6>
                    <md-field :class="{ 'md-invalid': errors.first($t('message.organizationName')) != null }">
                        <label>{{ $t("message.organizationName") }}</label>
                        <md-input
                            id="organizationName"
                            v-model="organizationName"
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            v-validate="'required'"
                            :content="$t('message.vtipyOrganizationName')"
                            :name="$t('message.organizationName')"
                            :placeholder="$t('message.organizationName')"
                            autocomplete="off"
                            type="text"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.organizationName")) }}</span>
                    </md-field>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipyAudioLevel')"
                        class="custom-field-slider"
                    >
                        <label>{{ $t("message.audioLevel") }}</label>
                        <a-slider
                            :max="100"
                            :min="0"
                            :step="1"
                            :value="audioAlertVolume * 100"
                            @change="(value) => (this.audioAlertVolume = value)"
                        />
                    </div>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipyOfflineMode')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.offlineMode") }}</label>
                        <md-switch v-model="offlineMode" class="md-primary ml-3" name="writing" required />
                    </div>
                    <md-field style="height: auto; background-color: #fff">
                        <md-textarea
                            id="autoStartChat"
                            v-model="autoStartChat"
                            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                            :content="$t('message.autoStartChat')"
                            :name="$t('message.autoStartChat')"
                            :placeholder="$t('message.autoStartChat')"
                        />
                    </md-field>

                    <md-button
                        v-model="editMode"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.tooltipOSRForm')"
                        class="custom-field-button"
                        @click="openModalForm()"
                        >{{ $t("message.changeOSRForm") }}
                    </md-button>
                    <b-modal
                        id="osr-form"
                        :title="editMode ? $t('message.updateOSRForm') : $t('message.newOSRForm')"
                        centered
                        hide-footer
                        size="lg"
                    >
                        <a-alert
                            v-if="$validator.errors.items.length && submitClicked"
                            :key="`alertContainer-${$i18n.locale}`"
                            :message="$t('message.error')"
                            class="mb-2"
                            showIcon
                            type="error"
                        >
                            <div slot="description">
                                <div v-for="err of $validator.errors.items">
                                    <span>{{ err.msg }}</span>
                                </div>
                            </div>
                        </a-alert>
                        <b-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSaveOsrForm">
                            <b-row>
                                <b-col md="12">
                                    <b-row>
                                        <b-col md="12">
                                            <b-card no-body>
                                                <b-tabs card no-fade>
                                                    <b-tab
                                                        v-for="language of languages"
                                                        :key="'tab' + language.code"
                                                        :title="language.name"
                                                    >
                                                        <b-row>
                                                            <b-col md="12">
                                                                <md-field
                                                                    :class="{
                                                                        'md-invalid':
                                                                            errors.first($t('message.osrTitle')) !=
                                                                            null,
                                                                    }"
                                                                >
                                                                    <label>{{ $t("message.osrTitle") }}</label>
                                                                    <md-input
                                                                        v-model="
                                                                            localOsrLabel.languageContent[language.code]
                                                                                .title
                                                                        "
                                                                        v-validate="
                                                                            language.code === defaultLang
                                                                                ? 'required'
                                                                                : ''
                                                                        "
                                                                        :data-vv-as="`${$t('message.osrTitle')} [${
                                                                            language.code
                                                                        }]`"
                                                                        :name="$t('message.osrTitle')"
                                                                        :placeholder="$t('message.osrTitleDescription')"
                                                                        autocomplete="off"
                                                                        trim
                                                                        type="text"
                                                                    ></md-input>
                                                                    <span class="md-error">
                                                                        {{ errors.first($t("message.osrTitle")) }}
                                                                    </span>
                                                                </md-field>
                                                            </b-col>
                                                            <b-col md="12">
                                                                <md-field
                                                                    :class="{
                                                                        'md-invalid':
                                                                            errors.first(
                                                                                $t('message.osrContentDescription')
                                                                            ) != null,
                                                                    }"
                                                                >
                                                                    <label>
                                                                        {{ $t("message.osrContentDescription") }}
                                                                    </label>
                                                                    <md-input
                                                                        v-model="
                                                                            localOsrLabel.languageContent[language.code]
                                                                                .content
                                                                        "
                                                                        v-validate="
                                                                            language.code === defaultLang
                                                                                ? 'required'
                                                                                : ''
                                                                        "
                                                                        :data-vv-as="`${$t(
                                                                            'message.osrContentDescription'
                                                                        )} [${language.code}]`"
                                                                        :name="$t('message.osrContentDescription')"
                                                                        :placeholder="
                                                                            $t('message.osrContentDescription')
                                                                        "
                                                                        autocomplete="off"
                                                                        trim
                                                                        type="text"
                                                                    ></md-input>
                                                                    <span class="md-error">
                                                                        {{
                                                                            errors.first(
                                                                                $t("message.osrContentDescription")
                                                                            )
                                                                        }}
                                                                    </span>
                                                                </md-field>
                                                            </b-col>
                                                        </b-row>
                                                    </b-tab>
                                                </b-tabs>
                                            </b-card>
                                        </b-col>
                                        <b-col md="12 mt-2">
                                            <b-button :disabled="loading" type="submit" variant="primary">
                                                <template v-if="!loading">
                                                    <span v-if="!editMode">{{ $t("message.save") }}</span>
                                                    <span v-else>{{ $t("message.update") }}</span>
                                                </template>
                                                <template v-else>
                                                    <font-awesome-icon icon="spinner" spin />
                                                </template>
                                            </b-button>
                                            <b-button @click="cancelForm()">
                                                <template>{{ $t("message.cancel") }}</template>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-modal>
                </b-col>
                <b-col class="mt-3" md="3">
                    <h6>{{ $t("message.features") }}</h6>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipySelectTopic')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.selectTopic") }}</label>
                        <md-switch v-model="subject" class="md-primary ml-3" name="subject" required />
                    </div>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipyAutoCallTransfer')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.autoCallTransfer") }}</label>
                        <md-switch v-model="autoTake" class="md-primary ml-3" name="auto_take" required />
                    </div>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipyCustomerTyping')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.customerTyping") }}</label>
                        <md-switch v-model="writing" class="md-primary ml-3" name="writing" required />
                    </div>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipyAgentTyping')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.agentTyping") }}</label>
                        <md-switch v-model="agentTyping" class="md-primary ml-3" name="writing" required />
                    </div>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipyQueueNumberVisibleFeature')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.queueNumberVisibleFeature") }}</label>
                        <md-switch
                            v-model="queueNumberVisible"
                            class="md-primary ml-3"
                            name="queueNumberVisible"
                            required
                        />
                    </div>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipyPrivateChatEnabled')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.privateChatEnabled") }}</label>
                        <md-switch
                            v-model="privateChatEnabled"
                            class="md-primary ml-3"
                            name="privateChatEnabled"
                            required
                        />
                    </div>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.bannedWordRestrictDesc')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.bannedWordRestrict") }}</label>
                        <md-switch v-model="bannedWord" class="md-primary ml-3" name="bannedWord" required />
                    </div>
                    <div
                        v-if="isAdmin"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.autoLoadIframeDesc')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.autoLoadIframe") }}</label>
                        <md-switch v-model="autoLoadIframe" class="md-primary ml-3" name="bannedWord" required />
                    </div>
                    <div
                        v-if="isAdmin"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.kmkAutoDepartmentBindDesc')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.kmkAutoDepartmentBind") }}</label>
                        <md-switch v-model="kmkAutoDepartmentBind" class="md-primary ml-3" name="bannedWord" required />
                    </div>
                </b-col>
                <b-col class="mt-3" md="3">
                    <h6>{{ $t("message.language") }}</h6>
                    <md-field
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :class="{
                            'md-invalid': errors.first($t('message.clientDefault')) != null,
                        }"
                        :content="$t('message.vtipyClientDefault')"
                    >
                        <label>{{ $t("message.clientDefault") }}</label>
                        <md-select
                            v-model="clientLanguage"
                            v-validate="'required|included:en,tr,ru'"
                            :name="`${$t('message.clientDefault')}`"
                            autocomplete="off"
                        >
                            <md-option>{{ $t("message.selectALanguage") }}</md-option>
                            <md-option v-for="lang in languages" :key="'item-' + lang.code" :value="lang.code"
                                >{{ lang.name }}
                            </md-option>
                        </md-select>
                        <span class="md-error">{{ errors.first($t("message.clientDefault")) }}</span>
                    </md-field>
                    <md-field
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :class="{
                            'md-invalid': errors.first($t('message.customerClientDefault')) != null,
                        }"
                        :content="$t('message.vtipyCustomerClientDefault')"
                    >
                        <label>{{ $t("message.customerClientDefault") }}</label>
                        <md-select
                            v-model="customerClientLanguage"
                            v-validate="'required|included:en,tr,ru'"
                            :name="`${$t('message.customerClientDefault')}`"
                            autocomplete="off"
                        >
                            <md-option>{{ $t("message.selectALanguage") }}</md-option>
                            <md-option v-for="lang in languages" :key="lang.code" :value="lang.code"
                                >{{ lang.name }}
                            </md-option>
                        </md-select>
                        <span class="md-error w-100">{{ errors.first($t("message.customerClientDefault")) }}</span>
                    </md-field>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipyCustomerClientLanguageDetect')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.customerClientLanguageDetect") }}</label>
                        <md-switch v-model="customerClientLanguageDetect" class="md-primary ml-3" required />
                    </div>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtipyVisitorPreferredLang')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.visitorPreferredLang") }}</label>
                        <md-switch v-model="visitorPreferredLang" class="md-primary ml-3" required />
                    </div>
                </b-col>
                <b-col class="mt-3" md="3">
                    <h6>{{ $t("message.chatTimingSettings") }}</h6>
                    <md-field
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :class="{
                            'md-invalid': errors.first($t('message.delayedTalkTime')) != null,
                        }"
                        :content="$t('message.vtipyDelayedTalkTime')"
                    >
                        <label>{{ $t("message.delayedTalkTime") }}</label>
                        <md-input
                            id="overdue-time-input"
                            v-model="overdueTime"
                            v-validate="'required|numeric|min:0'"
                            :min="0"
                            :name="$t('message.delayedTalkTime')"
                            autocomplete="off"
                            placeholder=">= 0"
                            step="1"
                            trim
                            type="number"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.delayedTalkTime")) }}</span>
                    </md-field>
                    <md-field
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :class="{
                            'md-invalid': errors.first($t('message.autoAssignLimit')) != null,
                        }"
                        :content="$t('message.vtipyAutoAssignLimit')"
                    >
                        <label>{{ $t("message.autoAssignLimit") }}</label>
                        <md-input
                            v-model="autoAssignDefaultLimit"
                            v-validate="'required|numeric|min:0'"
                            :min="0"
                            :name="$t('message.autoAssignLimit')"
                            autocomplete="off"
                            placeholder=">= 0"
                            step="1"
                            trim
                            type="number"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.autoAssignLimit")) }}</span>
                    </md-field>
                    <md-field
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :class="{
                            'md-invalid': errors.first($t('message.customerDownTimeWhenRepExit')) != null,
                        }"
                        :content="$t('message.vtipyCustomerDownTimeWhenRepExit')"
                    >
                        <label>{{ $t("message.wasted") }}</label>
                        <md-input
                            v-model="lostConversationTime"
                            v-validate="'required|numeric|min:0'"
                            :min="0"
                            :name="$t('message.customerDownTimeWhenRepExit')"
                            autocomplete="off"
                            placeholder=">= 0"
                            step="1"
                            trim
                            type="number"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.customerDownTimeWhenRepExit")) }}</span>
                    </md-field>
                    <md-field
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :class="{
                            'md-invalid': errors.first($t('message.disconnectTime')) != null,
                        }"
                        :content="$t('message.tippyDisconnectTime')"
                    >
                        <label>{{ $t("message.disconnectTime") }}</label>
                        <md-input
                            v-model="disconnectTime"
                            v-validate="'required|numeric|min_value:20'"
                            :min="20"
                            :name="$t('message.disconnectTime')"
                            autocomplete="off"
                            placeholder=">= 20"
                            step="1"
                            trim
                            type="number"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.disconnectTime")) }}</span>
                    </md-field>
                </b-col>

                <b-col class="mt-3" md="3">
                    <h6>{{ $t("message.bubbleSettings") }}</h6>
                    <md-field>
                        <label>{{ $t("message.chatPosition") }}</label>
                        <md-select
                            v-model="position"
                            v-validate="'required'"
                            :name="$t('message.chatPosition')"
                            autocomplete="off"
                        >
                            <md-option :value="undefined">{{ $t("message.chatPositionSelect") }}</md-option>
                            <md-option
                                v-for="(opt, index) of ['bottomLeft', 'left', 'bottomRight', 'right']"
                                :key="index"
                                :value="opt"
                                >{{ $t("message." + opt) }}
                            </md-option>
                        </md-select>
                    </md-field>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.vtippyAutoHideBubble')"
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.autoHideBubble") }}</label>
                        <md-switch v-model="autoHideBubble" class="md-primary ml-3" name="subject" required />
                    </div>
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="
                            !!isProPlanUser
                                ? $t('message.vtipyBrandVisibility')
                                : $t('message.vtipyBrandVisibilityForced')
                        "
                        class="custom-field-switch"
                    >
                        <label>{{ $t("message.brandVisibility") }}</label>
                        <md-switch
                            v-model="brandVisible"
                            class="md-primary ml-3"
                            name="subject"
                            :disabled="!isProPlanUser"
                            required
                        />
                    </div>
                    <div
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="$t('message.bubbleIcon')"
                        class="custom-field-slider"
                    >
                        <div class="d-flex justify-content-between align-items-center">
                            <label>{{ $t("message.bubbleIcon") }}</label>
                            <img
                                v-if="newIcon || (!!settings.bubble && preDefined === 0)"
                                :src="bubbleIcon"
                                alt="bubble"
                                class="img-thumbnail img-select"
                                style="width: 100px; height: 100px; object-fit: contain"
                                @click="$bvModal.show('bubble-icon-modal')"
                            />
                            <div v-else @click="$bvModal.show('bubble-icon-modal')">
                                <Bubble1
                                    v-if="preDefined === 1"
                                    :color="bubbleColor"
                                    class="img-thumbnail img-select"
                                    style="width: 100px; height: 100px; object-fit: contain"
                                />
                                <Bubble2
                                    v-if="preDefined === 2"
                                    :color="bubbleColor"
                                    class="img-thumbnail img-select"
                                    style="width: 100px; height: 100px; object-fit: contain"
                                />
                                <Bubble3
                                    v-if="preDefined === 3"
                                    :color="bubbleColor"
                                    class="img-thumbnail img-select"
                                    style="width: 100px; height: 100px; object-fit: contain"
                                />
                                <Bubble4
                                    v-if="preDefined === 4"
                                    :color="bubbleColor"
                                    class="img-thumbnail img-select"
                                    style="width: 100px; height: 100px; object-fit: contain"
                                />
                                <Bubble5
                                    v-if="preDefined === 5"
                                    :color="bubbleColor"
                                    class="img-thumbnail img-select"
                                    style="width: 100px; height: 100px; object-fit: contain"
                                />
                                <Bubble6
                                    v-if="preDefined === 6"
                                    :color="bubbleColor"
                                    class="img-thumbnail img-select"
                                    style="width: 100px; height: 100px; object-fit: contain"
                                />
                                <Bubble7
                                    v-if="preDefined === 7"
                                    :color="bubbleColor"
                                    class="img-thumbnail img-select"
                                    style="width: 100px; height: 100px; object-fit: contain"
                                />
                                <Bubble8
                                    v-if="preDefined === 8"
                                    :color="bubbleColor"
                                    class="img-thumbnail img-select"
                                    style="width: 100px; height: 100px; object-fit: contain"
                                />
                            </div>
                        </div>
                        <md-field v-if="preDefined !== 0" class="theme-field my-3">
                            <label for="bubbleColor">{{ $t("message.bubbleColor") }}</label>
                            <input id="bubbleColor" v-model="bubbleColor" class="theme-color-input" type="color" />
                        </md-field>
                        <b-modal
                            id="bubble-icon-modal"
                            :title="$t('message.bubbleIcon')"
                            centered
                            hide-footer
                            size="lg"
                        >
                            <b-row>
                                <b-col class="bubbles-modal" md="12">
                                    <label>{{ $t("message.preDefined") }}</label>
                                    <b-row>
                                        <b-col class="mt-3" md="3">
                                            <img
                                                :class="{ selected: preDefined === 1 }"
                                                src="../../assets/bubbles/btn1.svg"
                                                style="width: 100px; height: 100px; object-fit: contain"
                                                @click="preDefined = 1"
                                            />
                                        </b-col>
                                        <b-col class="mt-3" md="3">
                                            <img
                                                :class="{ selected: preDefined === 2 }"
                                                src="../../assets/bubbles/btn2.svg"
                                                style="width: 100px; height: 100px; object-fit: contain"
                                                @click="preDefined = 2"
                                            />
                                        </b-col>
                                        <b-col class="mt-3" md="3">
                                            <img
                                                :class="{ selected: preDefined === 3 }"
                                                src="../../assets/bubbles/btn3.svg"
                                                style="width: 100px; height: 100px; object-fit: contain"
                                                @click="preDefined = 3"
                                            />
                                        </b-col>
                                        <b-col class="mt-3" md="3">
                                            <img
                                                :class="{ selected: preDefined === 4 }"
                                                src="../../assets/bubbles/btn4.svg"
                                                style="width: 100px; height: 100px; object-fit: contain"
                                                @click="preDefined = 4"
                                            />
                                        </b-col>
                                        <b-col class="mt-3" md="3">
                                            <img
                                                :class="{ selected: preDefined === 5 }"
                                                src="../../assets/bubbles/btn5.svg"
                                                style="width: 100px; height: 100px; object-fit: contain"
                                                @click="preDefined = 5"
                                            />
                                        </b-col>
                                        <b-col class="mt-3" md="3">
                                            <img
                                                :class="{ selected: preDefined === 6 }"
                                                src="../../assets/bubbles/btn6.svg"
                                                style="width: 100px; height: 100px; object-fit: contain"
                                                @click="preDefined = 6"
                                            />
                                        </b-col>
                                        <b-col class="mt-3" md="3">
                                            <img
                                                :class="{ selected: preDefined === 7 }"
                                                src="../../assets/bubbles/btn7.svg"
                                                style="width: 100px; height: 100px; object-fit: contain"
                                                @click="preDefined = 7"
                                            />
                                        </b-col>
                                        <b-col class="mt-3" md="3">
                                            <img
                                                :class="{ selected: preDefined === 8 }"
                                                src="../../assets/bubbles/btn8.svg"
                                                style="width: 100px; height: 100px; object-fit: contain"
                                                @click="preDefined = 8"
                                            />
                                        </b-col>
                                        <b-col class="mt-3" md="12">
                                            <label>{{ $t("message.customIcon") }}</label>
                                            <div class="d-flex align-items-center">
                                                <md-button class="mr-3" @click="selectFile">
                                                    <md-icon>upload</md-icon>
                                                </md-button>
                                                <img
                                                    v-if="
                                                        newIcon || (!!settings.bubble && !!settings.bubble.customIcon)
                                                    "
                                                    :class="{ selected: preDefined === 0 }"
                                                    :src="bubbleIcon"
                                                    alt="bubble"
                                                    style="width: 100px; height: 100px; object-fit: contain"
                                                    @click="preDefined = 0"
                                                />
                                            </div>
                                        </b-col>
                                        <b-col md="12 mt-2">
                                            <b-button variant="primary" @click="selectBubble">
                                                <template>
                                                    <span>{{ $t("message.ok") }}</span>
                                                </template>
                                            </b-button>
                                            <b-button @click="$bvModal.hide('bubble-icon-modal')">
                                                <template>{{ $t("message.cancel") }}</template>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-modal>
                    </div>
                </b-col>
                <b-col class="mt-3" md="3">
                    <h6>{{ $t("message.themeSettings") }}</h6>
                    <md-field>
                        <label>{{ $t("message.theme") }}</label>
                        <md-select
                            v-model="preferredThemeColor"
                            v-validate="'required'"
                            :data-vv-as="`${$t('message.preferredThemeColor')}`"
                            :name="$t('message.preferredThemeColor')"
                            autocomplete="off"
                        >
                            <md-option :value="undefined">{{ $t("message.selectATheme") }}</md-option>
                            <md-option v-for="(opt, index) of allThemeColors" :key="'color-' + index" :value="opt"
                                >{{ opt }}
                            </md-option>
                            <md-option value="custom">{{ $t("theme.selectCustom") }}</md-option>
                        </md-select>
                    </md-field>
                    <div v-if="preferredThemeColor === 'custom'">
                        <md-field>
                            <button class="previewButton" @click="previewApp">
                                {{ isPreviewActive ? $t("message.closePreviewColors") : $t("message.previewColors") }}
                            </button>
                        </md-field>

                        <!-- COLOR  -->

                        <div
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('theme.headerColor1A')"
                            class="custom-field-slider"
                        >
                            <md-field class="theme-field">
                                <label for="themecolor1">{{ $t("theme.headerColor1") }}</label>
                                <input id="themecolor1" v-model="themeColor1" class="theme-color-input" type="color" />
                            </md-field>
                            <label>{{ $t("theme.opacity") }}</label>
                            <a-slider
                                :max="100"
                                :min="0"
                                :step="5"
                                :value="themeColor1A"
                                @change="(value) => (this.themeColor1A = value)"
                            />
                        </div>

                        <div
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('theme.headerColor2A')"
                            class="custom-field-slider"
                        >
                            <md-field class="theme-field">
                                <label for="themecolor2">{{ $t("theme.headerColor2") }}</label>
                                <input id="themecolor2" v-model="themeColor2" class="theme-color-input" type="color" />
                            </md-field>
                            <label>{{ $t("theme.opacity") }}</label>
                            <a-slider
                                :max="100"
                                :min="0"
                                :step="5"
                                :value="themeColor2A"
                                @change="(value) => (this.themeColor2A = value)"
                            />
                        </div>

                        <div
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('theme.backgroundColorA')"
                            class="custom-field-slider"
                        >
                            <md-field class="theme-field">
                                <label for="themecolor3">{{ $t("theme.backgroundColor") }}</label>
                                <input id="themecolor3" v-model="themeColor3" class="theme-color-input" type="color" />
                            </md-field>
                            <label>{{ $t("theme.opacity") }}</label>
                            <a-slider
                                :max="100"
                                :min="0"
                                :step="5"
                                :value="themeColor3A"
                                @change="(value) => (this.themeColor3A = value)"
                            />
                        </div>

                        <div
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('theme.backgroundColor2A')"
                            class="custom-field-slider"
                        >
                            <md-field class="theme-field">
                                <label for="themecolor6">{{ $t("theme.backgroundColor2") }}</label>
                                <input id="themecolor6" v-model="themeColor6" class="theme-color-input" type="color" />
                            </md-field>
                            <label>{{ $t("theme.opacity") }}</label>
                            <a-slider
                                :max="100"
                                :min="0"
                                :step="5"
                                :value="themeColor6A"
                                @change="(value) => (this.themeColor6A = value)"
                            />
                        </div>

                        <md-field class="theme-field">
                            <label for="themecolor4">{{ $t("theme.textColor") }}</label>
                            <input id="themecolor4" v-model="themeColor4" class="theme-color-input" type="color" />
                        </md-field>

                        <md-field class="theme-field">
                            <label for="themecolor5">{{ $t("theme.errorTheme") }}</label>
                            <input id="themecolor5" v-model="themeColor5" class="theme-color-input" type="color" />
                        </md-field>

                        <md-field class="theme-field">
                            <label for="chatBubbleBackground">{{ $t("theme.bubbleBackground") }}</label>
                            <input
                                id="chatBubbleBackground"
                                v-model="chatBubbleBackground"
                                class="theme-color-input"
                                type="color"
                            />
                        </md-field>

                        <md-field class="theme-field">
                            <label for="chatBubbleText">{{ $t("theme.bubbleText") }}</label>
                            <input
                                id="chatBubbleText"
                                v-model="chatBubbleText"
                                class="theme-color-input"
                                type="color"
                            />
                        </md-field>
                    </div>
                </b-col>

                <b-col class="mt-3" md="6">
                    <div class="">
                        <h6
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('message.vtipyLoginlessChat')"
                            class="d-flex align-items-center"
                        >
                            {{ $t("message.loginlessChat") }}
                            <md-switch
                                v-model="loginFormRequired"
                                class="md-primary m-0 ml-3"
                                name="loginFormRequired"
                                required
                            >
                                <span v-if="loginFormRequired">{{ $t("message.active") }}</span>
                                <span v-else>{{ $t("message.passive") }}</span>
                            </md-switch>
                        </h6>
                        <h6
                            v-if="loginFormRequired"
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="$t('message.vtipyCustomLogin')"
                            class="d-flex align-items-center"
                        >
                            {{ $t("message.customLoginFormSettingsTitle") }}
                            <md-switch
                                v-model="customLoginForm"
                                class="md-primary m-0 ml-3"
                                name="customLoginForm"
                                required
                            >
                                <span v-if="customLoginForm">{{ $t("message.active") }}</span>
                                <span v-else>{{ $t("message.passive") }}</span>
                            </md-switch>
                        </h6>
                    </div>

                    <div v-if="customLoginForm && loginFormRequired">
                        <CustomLoginForm />
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mt-3 mb-3" md="12">
                    <md-card>
                        <md-card-content>
                            <AvailabilityConfig />
                        </md-card-content>
                    </md-card>
                </b-col>
            </b-row>
        </b-container>
        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPencilAlt, faPlusCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import * as _ from "lodash";
import { log2 } from "../../utils/log2";
import { baseUrl } from "../../utils/utils";
import ChatBar from "../../components/ChatBar";
import CustomLoginForm from "../../components/CustomLoginForm";
import { sendSocketMessage } from "../../utils/socketStream";
import { toArray, toObject } from "../../utils/languageContent";
import { uploadAsset } from "../../api/assetUpload";
import mimeTypes from "../../components/util/mimeTypes";
import axios from "axios";
import Bubble1 from "../../components/svg/bubbles/Bubble1";
import Bubble2 from "../../components/svg/bubbles/Bubble2";
import Bubble3 from "../../components/svg/bubbles/Bubble3";
import Bubble4 from "../../components/svg/bubbles/Bubble4";
import Bubble5 from "../../components/svg/bubbles/Bubble5";
import Bubble6 from "../../components/svg/bubbles/Bubble6";
import Bubble7 from "../../components/svg/bubbles/Bubble7";
import Bubble8 from "../../components/svg/bubbles/Bubble8";
import AvailabilityConfig from "../../components/fast-initialize/AvailabilityConfig";

library.add(faPencilAlt, faTimes, faPlusCircle);
const log = log2("Settings");
const osrtInitialObject = {
    _id: null,
    languageContent: {
        tr: {
            title: "Çevrimdışı",
            content:
                "Hiç bir temsilcimiz şuanda aktif değil. Mesajınızı ileterek size mail yoluyla ulaşmamızı ister misiniz?",
        },
        en: {
            title: "Offline",
            content: "There is no active representative right now. We can reach you with email if you send a message.",
        },
        ru: {
            title: "не в сети",
            content:
                "Сейчас активного представителя нет. Мы свяжемся с вами по электронной почте, если вы отправите сообщение.",
        },
    },
};
export default {
    name: "Settings",
    components: {
        AppBreadCrumb,
        ChatBar,
        CustomLoginForm,
        Bubble1,
        Bubble2,
        Bubble3,
        Bubble4,
        Bubble5,
        Bubble6,
        Bubble7,
        Bubble8,
        AvailabilityConfig,
    },
    data() {
        return {
            isBusy: true,
            submitClicked: false,
            editMode: false,
            loading: false,
            localOsrLabel: _.cloneDeep(osrtInitialObject),
            handleSave: _.debounce((newSettings) => {
                const isValid = Date.now() - (this.mountedTime || Date.now()) > 2000; // defaulttan gerçeğe geçerken bir kere sunucuya gitmesini engellemek için alternatif başka çözüm var sa yapalım
                log("handleSave runned", {
                    newSettings,
                    initialized: this.settingInitialized,
                    isValid,
                    mountedTime: this.mountedTime,
                    diff: Date.now() - (this.mountedTime || Date.now()),
                });
                if (isValid) {
                    this.submitClicked = true;
                    const self = this;
                    this.$validator.validateAll().then((response) => {
                        if (response) {
                            self.updateSettings(newSettings)
                                .then(() => {
                                    sendSocketMessage("admin settings-updated", {
                                        siteId: self.site._id,
                                    });
                                    self.$toasted.show(self.$t("message.settingsSaved"), {
                                        duration: 3000,
                                        position: "bottom-center",
                                    });
                                })
                                .finally(() => {
                                    self.submitClicked = false;
                                });
                        } else {
                            self.$toasted.error(self.$t("message.settingFormWrong"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        }
                    });
                }
            }, 1000).bind(this),
            isPreviewActive: false,
            alphaMap: {
                100: "ff",
                95: "f2",
                90: "e6",
                85: "d9",
                80: "cc",
                75: "bf",
                70: "b3",
                65: "a6",
                60: "99",
                55: "8c",
                50: "80",
                45: "73",
                40: "66",
                35: "59",
                30: "4d",
                25: "40",
                20: "33",
                15: "26",
                10: "1a",
                5: "0d",
                0: "00",
            },
            alphaMapRev: {
                ff: "100",
                f2: "95",
                e6: "90",
                d9: "85",
                cc: "80",
                bf: "75",
                b3: "70",
                a6: "65",
                99: "60",
                "8c": "55",
                80: "50",
                73: "45",
                66: "40",
                59: "35",
                "4d": "30",
                40: "25",
                33: "20",
                26: "15",
                "1a": "10",
                "0d": "5",
                "00": "0",
            },
            newIcon: null,
            preDefined: 1,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            settingInitialized: (state) => state.setting.initialized,
            languages: (state) => state.language.languages,
            defaultLang: (state) => state.setting.settings.language.clientDefault,
            allThemeColors: (state) => state.setting.allThemeColors,
            site: (state) => state.site.site,
            isAdmin: (state) => state.auth.adminUser != null,
            isProPlanUser: (state) => _.get(state.setting.settings, "plan.selectedPlan") === "pro",
            bubbleIcon() {
                let { customIcon } = this.settings.bubble;
                if (this.newIcon || customIcon) {
                    let { path, _id, ext } = this.newIcon || customIcon;
                    return `https://static.supsis.live/${path + _id}${ext ? "." + ext : ""}`;
                }
                return undefined;
            },
        }),
        organizationName: {
            get() {
                return this.settings.organizationName;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "organizationName",
                    value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        autoStartChat: {
            get() {
                return this.settings.autoStartChatMessage;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "autoStartChatMessage",
                    value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        autoTake: {
            get() {
                return this.settings.autoTake == 1;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "autoTake",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        audioAlertVolume: {
            get() {
                return this.settings.audioAlertVolume;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "audioAlertVolume",
                    value: value / 100,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        subject: {
            get() {
                return this.settings.subject == 1;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "subject",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        writing: {
            get() {
                return this.settings.writing == 1;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "writing",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        agentTyping: {
            get() {
                return this.settings.agentTyping;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "agentTyping",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        queueNumberVisible: {
            get() {
                return this.settings.queueNumberVisible;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "queueNumberVisible",
                    value: value,
                });
                log("queueNumberVisible changed", newSettings);

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        offlineMode: {
            get() {
                return this.settings.offlineMode;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "offlineMode",
                    value: value,
                });
                log("offlineMode changed", newSettings);

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        bannedWord: {
            get() {
                return this.settings.bannedWordMarking;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "bannedWordMarking",
                    value: value,
                });
                log("offlineMode changed", newSettings);

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        autoLoadIframe: {
            get() {
                return this.settings.autoLoadIframe;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "autoLoadIframe",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        kmkAutoDepartmentBind: {
            get() {
                return this.settings.kmkAutoDepartmentBind;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "kmkAutoDepartmentBind",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        overdueTime: {
            get() {
                return this.settings.overdueTime;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "overdueTime",
                    value: parseInt(value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        activeAgentRateConversationCount: {
            get() {
                return this.settings.activeAgentRateConversationCount;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "activeAgentRateConversationCount",
                    value: parseInt(value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        delayTime: {
            get() {
                return this.settings.delayTime;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "delayTime",
                    value: parseInt(value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        autoAssignDefaultLimit: {
            get() {
                log.info("autoAssignDefaultLimit get called", this.settings.autoAssignDefaultLimit);
                return this.settings.autoAssignDefaultLimit;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "autoAssignDefaultLimit",
                    value: parseInt(value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        lostConversationTime: {
            get() {
                log.info("lostConversationTime get called", this.settings.lostConversationTime);
                return this.settings.lostConversationTime;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "lostConversationTime",
                    value: parseInt(value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        language: {
            get() {
                return this.settings.language;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "language",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        clientLanguage: {
            get() {
                return this.settings.language.clientDefault;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "language.clientDefault",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        customerClientLanguage: {
            get() {
                return this.settings.language.customerClientDefault;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "language.customerClientDefault",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        customerClientLanguageDetect: {
            get() {
                return this.settings.language.customerClientLanguageDetect == 1;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "language.customerClientLanguageDetect",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        visitorPreferredLang: {
            get() {
                return this.settings.visitorPreferredLang;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "visitorPreferredLang",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        preferredThemeColor: {
            get() {
                log("preferredThemeColor", { ...this.settings });
                return this.settings.chatCustomizationSettings.preferredThemeColor;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.preferredThemeColor",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor1: {
            get() {
                log("themeColor1", { ...this.settings });
                return (this.settings.chatCustomizationSettings.themeColor1 || "#000000").substr(0, 7);
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor1",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor2: {
            get() {
                log("themeColor2", { ...this.settings });
                return (this.settings.chatCustomizationSettings.themeColor2 || "#000000").substr(0, 7);
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor2",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor3: {
            get() {
                log("themeColor3", { ...this.settings });
                return (this.settings.chatCustomizationSettings.themeColor3 || "#000000").substr(0, 7);
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor3",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor4: {
            get() {
                log("themeColor4", { ...this.settings });
                return (this.settings.chatCustomizationSettings.themeColor4 || "#000000").substr(0, 7);
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor4",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor5: {
            get() {
                log("themeColor5", { ...this.settings });
                return (this.settings.chatCustomizationSettings.themeColor5 || "#000000").substr(0, 7);
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor5",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor6: {
            get() {
                log("themeColor6", { ...this.settings });
                return (this.settings.chatCustomizationSettings.themeColor6 || "#000000").substr(0, 7);
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor6",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        bubbleColor: {
            get() {
                log("bubbleColor", { ...this.settings });
                return (this.settings.bubble && this.settings.bubble.bubbleColor) || "#000000";
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "bubble.bubbleColor",
                    value: value,
                });
                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },

        themeColor1A: {
            get() {
                return (
                    this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor1.substr(7, 9).toLowerCase()] ||
                    100
                );
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor1",
                    value: this.addAlpha(this.themeColor1, value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor2A: {
            get() {
                return (
                    this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor2.substr(7, 9).toLowerCase()] ||
                    100
                );
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor2",
                    value: this.addAlpha(this.themeColor2, value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor3A: {
            get() {
                return (
                    this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor3.substr(7, 9).toLowerCase()] ||
                    100
                );
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor3",
                    value: this.addAlpha(this.themeColor3, value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor4A: {
            get() {
                return (
                    this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor4.substr(7, 9).toLowerCase()] ||
                    100
                );
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor4",
                    value: this.addAlpha(this.themeColor4, value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor5A: {
            get() {
                return (
                    this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor5.substr(7, 9).toLowerCase()] ||
                    100
                );
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor5",
                    value: this.addAlpha(this.themeColor5, value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        themeColor6A: {
            get() {
                return (
                    this.alphaMapRev[this.settings.chatCustomizationSettings.themeColor6.substr(7, 9).toLowerCase()] ||
                    100
                );
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.themeColor6",
                    value: this.addAlpha(this.themeColor6, value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },

        chatBubbleBackground: {
            get() {
                log("chatBubbleBackground", { ...this.settings });
                return this.settings.chatCustomizationSettings.chatBubbleBackground.substr(0, 7);
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.chatBubbleBackground",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        chatBubbleText: {
            get() {
                log("chatBubbleText", { ...this.settings });
                return this.settings.chatCustomizationSettings.chatBubbleText.substr(0, 7);
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.chatBubbleText",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },

        chatBubbleBackgroundA: {
            get() {
                return (
                    this.alphaMapRev[
                        this.settings.chatCustomizationSettings.chatBubbleBackground.substr(7, 9).toLowerCase()
                    ] || 100
                );
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.chatBubbleBackground",
                    value: this.addAlpha(this.chatBubbleBackground, value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        chatBubbleTextA: {
            get() {
                return (
                    this.alphaMapRev[
                        this.settings.chatCustomizationSettings.chatBubbleText.substr(7, 9).toLowerCase()
                    ] || 100
                );
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.chatBubbleText",
                    value: this.addAlpha(this.chatBubbleText, value),
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },

        position: {
            get() {
                return this.settings.chatCustomizationSettings.position;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "chatCustomizationSettings.position",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        osrLabels: {
            get() {
                log("osrLabels", { ...this.settings });
                return toObject(this.settings.osrLabels);
            },
            set(value) {},
        },
        catalogContentFeature: {
            get() {
                return this.settings.catalogContentFeature;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "catalogContentFeature",
                    value: value,
                });
                log("handle save calling", {
                    init: this.settingInitialized,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        brandVisible: {
            get() {
                return this.settings.brandVisible;
            },
            set(value) {
                const newValue = this.isProPlanUser ? value : 1;
                log("brandVisible", { newValue, isProPlanUser: this.isProPlanUser });
                if (this.settings.brandVisible !== newValue) {
                    const newSettings = this.setSettingValue({
                        setting: "brandVisible",
                        value: newValue,
                    });

                    if (newSettings.then) {
                        newSettings.then((x) => this.handleSave(x));
                    } else {
                        this.handleSave(newSettings);
                    }
                }
            },
        },
        autoHideBubble: {
            get() {
                return this.settings.autoHideBubble;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "autoHideBubble",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        privateChatEnabled: {
            get() {
                return this.settings.privateChatEnabled;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "privateChatEnabled",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        customLoginForm: {
            get() {
                return this.settings.customLoginFormEnabled;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "customLoginFormEnabled",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        loginFormRequired: {
            get() {
                return this.settings.loginFormRequired;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "loginFormRequired",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        disconnectTime: {
            get() {
                return this.settings.disconnectTime;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "disconnectTime",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        baseUrl: baseUrl,
        cancelForm() {
            this.$bvModal.hide("osr-form");
            this.editMode = false;
        },
        openModalForm() {
            this.$bvModal.show("osr-form");
        },
        handleSaveOsrForm() {
            this.submitClicked = true;
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    Object.keys(this.localOsrLabel.languageContent).forEach((key) => {
                        if (!this.localOsrLabel.languageContent[key].title) {
                            this.localOsrLabel.languageContent[key].title =
                                this.localOsrLabel.languageContent[this.defaultLang].title;
                            this.localOsrLabel.languageContent[key].content =
                                this.localOsrLabel.languageContent[this.defaultLang].content;
                        }
                    });
                    const result = this.setSettingValue({
                        value: toArray(this.localOsrLabel),
                        setting: "osrLabels",
                    });

                    result
                        .then((r) => {
                            this.handleSave(r);
                            this.$bvModal.hide("osr-form");
                            // this.$toasted.show(this.$t('message.osrFromMessageSaved'), {
                            //     duration: 3000,
                            //     position: 'bottom-center'
                            // });
                        })
                        .finally(() => {
                            this.loading = false;
                            this.editMode = false;
                            this.submitClicked = false;
                        });
                } else {
                    log("validation error", response, this.$validator);
                    this.loading = false;
                }
            });
        },
        integrationScript() {
            const isProduction = process.env.PRODUCTION === "true";
            const hostname = this.site.customerClientAddress;
            const protocol = isProduction ? "https" : "http";
            const path = isProduction ? "static/js/loader.js" : "loader.js";
            return `${protocol}://${hostname}/${path}`;
        },
        previewApp() {
            if (this.isPreviewActive) {
                const script = document.getElementById("previewScript");
                log("previewApp  delete script ", script);
                if (script) script.parentNode.removeChild(script);
                const lsOpenBtn = document.getElementById("ls-openButton");
                if (lsOpenBtn) lsOpenBtn.parentNode.removeChild(lsOpenBtn);
                const lsContainer = document.getElementById("ls-container");
                if (lsContainer) lsContainer.parentNode.removeChild(lsContainer);
                this.isPreviewActive = false;
            } else {
                log("previewApp  add script ", this.integrationScript());
                const script = document.createElement("script");
                script.type = "text/javascript";
                script.src = this.integrationScript();
                script.id = "previewScript";
                document.head.appendChild(script);

                let openInterval = setInterval(() => {
                    let lsOpenBtn = document.getElementById("ls-openButton");
                    if (lsOpenBtn) {
                        lsOpenBtn.click();
                        clearInterval(openInterval);
                    }
                }, 1000);
                this.isPreviewActive = true;
            }
        },
        addAlpha(hex, e) {
            hex = hex.substring(1).split("");
            if (hex.length === 8) {
                hex.pop();
                hex.pop();
            }
            hex = "#" + hex.join("");
            return hex + this.alphaMap[e];
        },
        beforeUpload(file) {
            const testImgFile = /^image\/(jpg|jpeg|png)$/.test(file.type);
            const testSize = file.size <= 20 * 1024 * 1024;
            return testImgFile && testSize;
        },
        selectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            let self = this;
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                if (this.beforeUpload(file)) {
                    let path = `${this.site._id}/chatBubble/`;
                    let { data } = await uploadAsset({
                        path,
                        mime: file.type,
                        ext: mimeTypes[file.type] || null,
                    });
                    await axios({
                        method: data.method,
                        url: data.url,
                        data: file,
                    });
                    const newSettings = this.setSettingValue({
                        setting: "bubble.customIcon",
                        value: data.asset._id,
                    });
                    if (newSettings.then) {
                        newSettings.then((x) => this.handleSave(x));
                    } else {
                        this.handleSave(newSettings);
                    }
                    self.preDefined = 0;
                    self.selectBubble();
                    self.newIcon = data.asset;
                } else {
                    log.warn("input is not suitable for send");
                    this.$toasted.error(this.$t("message.assetOversizeWithExt"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                }
            };
            fileEl.click();
        },
        selectBubble() {
            const newSettings = this.setSettingValue({
                setting: "bubble.preDefined",
                value: this.preDefined,
            });
            if (newSettings.then) {
                newSettings.then((x) => this.handleSave(x));
            } else {
                this.handleSave(newSettings);
            }
            this.$bvModal.hide("bubble-icon-modal");
        },
    },
    mounted() {
        const settings = this.settings;
        log("Settings mounted", {
            ...settings,
        });
        this.getSettings().then(() => {
            this.isBusy = false;
            this.localOsrLabel = toObject(this.settings.osrLabels);
            if (!!this.settings.bubble) this.preDefined = parseInt(this.settings.bubble.preDefined);
        });
        this.mountedTime = Date.now();
    },
    created() {
        log("Settings created", this.settings.audioAlertVolume);
    },
    updated() {
        /*log("updated", "submitClicked", this.handleSave)*/
        if (this.$validator.locale !== this.$i18n.locale) {
            this.$validator.localize(this.$i18n.locale);
            if (this.submitClicked) this.$validator.validateAll();
            this.$forceUpdate();
        }
    },
    watch: {
        settings(old, newValue) {
            log("settings change watch", { old, newValue });
        },
        editMode(newVal) {
            this.editMode ? this.$bvModal.show("osr-form") : this.$bvModal.hide("osr-form");
        },
    },
};
</script>

<style lang="scss">
.new-theme {
    #settingsPage {
        .theme-field {
            background-color: #ffffff;

            .theme-color-input {
                border: none;
                background-color: transparent;
                height: 100%;
                width: 40%;
                padding: 6px;
                cursor: pointer;
            }
        }

        .container-fluid {
            padding: 0 30px;
        }

        h6 {
            font-family: Poppins;
            font-weight: 500;
            color: #181c32;
            font-size: 16px;
        }

        .custom-field-slider {
            background-color: #ffffff;
            border-radius: 6px;
            padding: 10px;
            margin-bottom: 25px;

            box-shadow: 0 0 3px #00000080;

            label {
                font-family: Poppins;
                font-size: 14px;
                font-weight: 300;
                color: #181c32;
                margin: 0;
            }
        }

        .custom-field-switch {
            display: flex;
            align-items: center;
            justify-content: space-between;

            background-color: #ffffff;
            border-radius: 6px;
            padding: 10px;
            margin-bottom: 25px;

            box-shadow: 0 0 3px #00000080;

            label {
                font-family: Poppins;
                font-size: 14px;
                font-weight: 300;
                color: #181c32;
                margin: 0;
            }

            .md-switch {
                margin: 0;

                &-label {
                    font-size: 12px;
                    color: #afafaf;
                }
            }
        }

        .custom-field-button {
            display: flex;
            align-items: center;
            justify-content: space-between;

            background-color: #ffffff;
            border-radius: 6px;
            padding: 10px;
            margin: 0;
            box-shadow: 0 0 3px #00000080;
        }

        .md-field {
            position: relative;
            min-height: auto;
            height: 32px;
            margin-bottom: 25px;
            border-radius: 6px;
            box-shadow: 0 0 3px #00000080;

            label {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 30px;
                left: auto;
                z-index: 2;
                pointer-events: none;

                font-family: Poppins;
                font-size: 12px;
                font-weight: 300;
                color: #afafaf;
            }

            input {
                background-color: #ffffff;
                border-radius: 6px;
                padding: 10px;

                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 100%;

                font-family: Poppins;
                font-size: 14px;
                font-weight: 300;
                color: #181c32;
            }

            i {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 0;
            }

            &::before,
            &::after {
                content: none;
            }
        }

        .previewButton {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background-color: #ffffff;
            border: none;
            border-radius: 6px;

            &:hover {
                background-color: #e2e2e2;
            }
        }
    }
}
</style>

<style lang="scss">
.bubbles-modal {
    img {
        transition: all 0.3s;
        cursor: pointer;
    }

    img:hover,
    .selected {
        border-radius: 12px;
        box-shadow: 0 0 3px #000000fa;
    }
}

.img-select {
    border: 1px dashed #303030;
    cursor: pointer;
}
</style>
